// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselHeader_root__UOeU7"};